module.exports = __webpack_public_path__ + "static/img/yytx13.6496643.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx13.png
// module id = 793
// module chunks = 0